import type { JSX } from 'preact';
import { Link, type LinkProps } from '@nespresso-design-system/components';

export type ClearAllFiltersProps = Pick<
  JSX.IntrinsicElements['a'],
  'onClick'
> & {
  label: string;
};

export default function FilterSelectionsClearAll({
  label,
  onClick
}: ClearAllFiltersProps) {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link label={label} onClick={onClick as LinkProps['onClick']} />
  );
}
